import { UAGLogo } from "@components/icons"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: inline-flex;
`

const Button = styled.span`
  align-items: center;
  justify-content: center;
  display: flex;
  padding: 0;
  outline: none;
  border: none;
  background: none;

  &:focus,
  &:active {
    outline: none;
  }

  @media ${breakpoints.laptop} {
    &:hover {
      cursor: pointer;
    }
  }
`

const LogoWrapper = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
`

export const UAGLogoWrapper = styled(LogoWrapper)`
  width: 52.12px;

  @media ${breakpoints.tablet} {
    width: 75px;
  }

  @media ${breakpoints.laptop} {
    width: 75px;
  }
`

interface LogoProps {}

const Logo: React.FC<LogoProps> = () => {
  return (
    <Container>
      <Link aria-label="Home" to="/">
        <Button>
          <UAGLogoWrapper>
            <UAGLogo strokeColor={colors.black} />
          </UAGLogoWrapper>
        </Button>
      </Link>
    </Container>
  )
}

export default Logo
